import { Text, View, Font, StyleSheet } from '@react-pdf/renderer';
import RobotoBold from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-Bold.ttf';
import RobotoExtraBold from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-ExtraBold.ttf';
import RobotoExtraBoldLight from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-ExtraLight.ttf';
import RobotoRegular from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-Regular.ttf';
import RobotoSemiBold from '../../Assets/Fonts/Roboto_Slab/static/RobotoSlab-SemiBold.ttf';
import React from 'react'

export default function ReceiptRaw({head, text}) {

Font.register({ family: 'roboto', fonts: [
    { src: RobotoRegular}, // font-style: normal, font-weight: normal
    { src: RobotoExtraBold, fontWeight:'bold'}, // font-style: normal, font-weight: normal
    { src: RobotoExtraBoldLight, fontWeight:800}, // font-style: normal, font-weight: normal
    { src: RobotoBold, fontWeight:900}, // font-style: normal, font-weight: normal
    { src: RobotoSemiBold, fontWeight:600}, // font-style: normal, font-weight: normal
]});

    // Create styles
const styles = StyleSheet.create({
    contentContainer:{
        display:'flex',
        flexDirection:'row',
        padding:'5px',
    },
    contentMainText:{
        fontSize:10,
        fontFamily:'roboto',
        // fontWeight:600,
        width:'30%',
        color:'#476b6b',
    },
    separator:{
        textAlign:'center',
        fontSize:10,
        fontFamily:'roboto',
        fontWeight:600,
        width:'10%',
    },
    contentSubText:{
        fontSize:10,
        fontFamily:'roboto',
        // fontWeight:'800',
        width:'60%',
        color:'#476b6b',
    },

});
  
  return (
    <View style={styles.contentContainer}>
        <Text style={styles.contentMainText}>
            {head}
        </Text>
        <Text style={styles.separator}>
                :
        </Text>
        <Text style={styles.contentSubText}>
            {text}
        </Text>
    </View>
  )
}
